export default function addProtocolToURL(url) {
  const RE = /^(https?:\/\/)/;
  if (url && !url.match(RE)) {
    return `http://${url}`; // Optimistic most sites will implement an http => https redirect
  }
  return url;
}
